var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter } from '@angular/core';
import { MyRemaxModes, ListingCategory, LoginSource } from '../../../classes/enums';
import { UserService } from '../../../services/user.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { LoginService } from '../../../services/login.service';
import { Router } from '@angular/router';
import { PreferencesService } from '../../../services/preferences.service';
import { CredentialsService } from '../../../services/credentials.service';
var MyRemaxMenuComponent = /** @class */ (function (_super) {
    __extends(MyRemaxMenuComponent, _super);
    function MyRemaxMenuComponent(userService, loginService, router, credentialService, preferencesService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.loginService = loginService;
        _this.router = router;
        _this.credentialService = credentialService;
        _this.preferencesService = preferencesService;
        _this.hideMenu = new EventEmitter();
        _this.ListingCategory = ListingCategory;
        _this.LoginSource = LoginSource;
        _this.isAuthenticated = false;
        _this.MyRemaxModes = MyRemaxModes;
        return _this;
    }
    MyRemaxMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.userService.currentUser.subscribe(function (currentUser) { return _this.currentUser = currentUser; }));
        this.addSub(this.preferencesService.favouriteAgentUrlChanged.subscribe(function (url) { return _this.favouriteAgentUrl = url; }));
        this.addSub(this.credentialService.isLoggedIn.subscribe(function (isAuthenticated) { return _this.isAuthenticated = isAuthenticated; }));
    };
    MyRemaxMenuComponent.prototype.logout = function () {
        var _this = this;
        this.loginService.logout().toPromise().then(function () {
            var queryIndex = _this.router.url.indexOf('?');
            var url = queryIndex === -1 ? _this.router.url : _this.router.url.substring(0, queryIndex);
            _this.router.navigate([url]);
        });
    };
    return MyRemaxMenuComponent;
}(HasSubscriptions));
export { MyRemaxMenuComponent };
